import * as React from 'react';
import {Slider, Handles, Tracks, Rail, Ticks} from 'react-compound-slider';
import './style.scss';

const handleStyle = (percent, handleColor) => ({
  left: `${percent}%`,
  backgroundColor: handleColor,
});

function Handle({handle: { id, value, percent, Ticks }, jumpPercents, handleColor, getHandleProps}) {
  let jumpResult = [percent, value];
  if (!Array.isArray(jumpPercents)) {
    jumpResult = jumpPercents(percent);
  }
  return (
    <div
      style={handleStyle(jumpResult[0], handleColor)}
      className="handleStyle"
      {...getHandleProps(id)}
    >
      <div style={{ fontFamily: 'Lato', fontSize: 11, marginTop: -23 }}>
        {jumpResult[1]}
      </div>
    </div>
  );
}

const trackStyle = (source, target, trackColor) => ({
  left: `${source.percent}%`,
  width: `${target - source.percent}%`,
  backgroundColor: trackColor,
});

function Track({ source, target, jumpPercents, trackColor, getTrackProps }) {
  let jumpResult = [target.percent];
  if (!Array.isArray(jumpPercents)) {
    jumpResult = jumpPercents(target.percent);
  }
  return (
    <div
       style={trackStyle(source, jumpResult[0], trackColor)}
       className="tracksStyle"
      {...getTrackProps()}
    />
  );
}

const tickStyle = (percent) => ({
  left: `${percent}%`,
});

function Tick({ tick, count, jumpPercents }) {
  let jumpResult = [tick.percent, tick.value];
  if (!Array.isArray(jumpPercents)) {
    jumpResult = jumpPercents(tick.percent);
  }
  return (
    <div>
      <div
        style={tickStyle(jumpResult[0])}
        className="tickStyle"
      />
      <div
        style={{
          position: 'absolute',
          marginTop: 60,
          fontSize: 10,
          textAlign: 'center',
          marginLeft: `${-(100 / count) / 2}%`,
          width: `${100 / count}%`,
          left: `${jumpResult[0]}%`,
        }}
      >
        {jumpResult[1]}
      </div>
    </div>
  );
}

export default ({
                  onChange,
                  tickValues = [0],
                  jumpPercents = [],
                  handleColor = '#fff',
                  trackColor = '#eee',
                  value = 0,
                }) => {
  return (
    <Slider
      className="sliderStyle"
      domain={[ 0, 1000 ]}
      values={[value]}
      step={50}
      onChange={onChange}
    >
      <Rail>
        {({ getRailProps }) => (
          <div className="railStyle" {...getRailProps()} />
        )}
      </Rail>
      <Handles>
        {({ handles, getHandleProps }) => (
          <div className="slider-handles">
            {handles.map((handle) => (
              <Handle
                key={handle.id}
                handle={handle}
                jumpPercents={jumpPercents}
                handleColor={handleColor}
                getHandleProps={getHandleProps}
              />
            ))}
          </div>
        )}
      </Handles>
      <Tracks right={false}>
        {({ tracks, getTrackProps }) => (
          <div className="slider-tracks">
            {tracks.map(({ id, source, target }) => (
              <Track
                key={id}
                source={source}
                target={target}
                jumpPercents={jumpPercents}
                trackColor={trackColor}
                getTrackProps={getTrackProps}
              />
            ))}
          </div>
        )}
      </Tracks>
      <Ticks values={tickValues}>
        {({ ticks }) => (
          <div className="slider-ticks">
            {ticks.map((tick) => (
              <Tick key={tick.id} tick={tick} count={ticks.length} jumpPercents={jumpPercents} />
            ))}
          </div>
        )}
      </Ticks>
    </Slider>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/Slider/index.tsx